import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { FaUsers, FaMapMarkedAlt, FaChartLine, FaBell, FaGlobeAmericas } from 'react-icons/fa';
import ScrollReveal from '../components/Animation/ScrollReveal';

const NavigationGuide = () => {
  const { t } = useTranslation();

  const guideItems = [
    {
      icon: <FaMapMarkedAlt className="text-4xl text-teal-600" />,
      title: t("navigation_guide.items.map.title"),
      description: t("navigation_guide.items.map.description"),
      action: t("navigation_guide.items.map.action"),
      link: "/map"
    },
    {
      icon: <FaUsers className="text-4xl text-teal-600" />,
      title: t("navigation_guide.items.team.title"),
      description: t("navigation_guide.items.team.description"),
      action: t("navigation_guide.items.team.action"),
      link: "/about"
    },
    {
      icon: <FaChartLine className="text-4xl text-teal-600" />,
      title: t("navigation_guide.items.analytics.title"),
      description: t("navigation_guide.items.analytics.description"),
      action: t("navigation_guide.items.analytics.action"),
      link: null
    },
    {
      icon: <FaGlobeAmericas className="text-4xl text-teal-600" />,
      title: t("navigation_guide.items.expansion.title"),
      description: t("navigation_guide.items.expansion.description"),
      action: t("navigation_guide.items.expansion.action"),
      link: null
    }
  ];

  return (
    <div className="bg-gradient-to-b from-blue-50 to-white py-16">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-2xl md:text-3xl text-center font-bold text-gray-800 mb-12">
          {t("navigation_guide.title")}
        </h2>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {guideItems.map((item, index) => (
            <ScrollReveal key={index} delay={index * 80}>
              <div className="bg-white rounded-lg shadow-md p-6 flex flex-col items-center text-center transition-all duration-300 hover:shadow-lg hover:-translate-y-1 h-full min-h-[220px]">
                <div className="mb-4">
                  {item.icon}
                </div>
                <h3 className="text-xl font-semibold mb-3">{item.title}</h3>
                <p className="text-gray-600 mb-4 flex-1">{item.description}</p>
                {item.link ? (
                  <Link 
                    to={item.link} 
                    className="mt-auto py-2 px-4 bg-teal-600 text-white rounded-md hover:bg-teal-700 transition-colors inline-block"
                  >
                    {item.action}
                  </Link>
                ) : (
                  <span className="mt-auto py-2 px-4 bg-gray-200 text-gray-700 rounded-md inline-block">
                    {item.action}
                  </span>
                )}
              </div>
            </ScrollReveal>
          ))}
        </div>
        
        <ScrollReveal delay={240} className="mt-14">
          <div className="bg-blue-50 rounded-lg p-6 border border-blue-100 flex items-center">
            <div className="mr-4 text-blue-600">
              <FaBell size={24} />
            </div>
            <div>
              <h3 className="font-bold text-lg mb-1">{t("navigation_guide.updates.title")}</h3>
              <p>{t("navigation_guide.updates.description")}</p>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </div>
  );
};

export default NavigationGuide;
